export default {
  'pick-tooltip': () => import('@icons/profile/pick-tooltip.svg'),
  'profile-calendar': () => import('@icons/profile/profile-calendar.svg'),
  'profile-crown': () => import('@icons/profile/profile-crown.svg'),
  'profile-graph': () => import('@icons/profile/profile-graph.svg'),
  'profile-image-delete': () =>
    import('@icons/profile/profile-image-delete.svg'),
  'profile-image-upload': () =>
    import('@icons/profile/profile-image-upload.svg'),
  'win-tooltip': () => import('@icons/profile/win-tooltip.svg'),
};
